module.exports = __webpack_public_path__ + "static/media/deng2.e0ac09be.png";